import React, { useState, useEffect } from "react";
import {
  Home,
  Users,
  Star,
  FileText,
  CreditCard,
  Settings,
  Building2,
  MapPin,
  Phone,
  Mail,
  Camera,
  Calendar,
  TrendingUp,
  IndianRupee,
  Eye,
  Bell,
  Menu,
  X,
  Upload,
  Plus,
  Edit3,
  Save,
  Trash2,
  CheckCircle,
  AlertCircle,
  Clock,
  Globe,
  Shield,
  Award,
  Search,
  Navigation,
  Loader2,
  Image as ImageIcon,
  VideoIcon,
  LogOut,
} from "lucide-react";

import { toast } from "react-hot-toast";
import api from "../../utils/axios";
import { useAuth } from "../../store/hooks/useRedux";


const PaymentSettings = ({ vendorData, onUpdate }) => {
    const [payoutInfo, setPayoutInfo] = useState({
      bankAccount: "",
      upiId: "",
    });
    const [loading, setLoading] = useState(false);
  
    useEffect(() => {
      if (vendorData?.vendor?.payoutInfo) {
        setPayoutInfo(vendorData?.vendor?.payoutInfo);
      }
    }, [vendorData]);
  
    const handleSave = async () => {
      try {
        setLoading(true);
        await api.put("/vendors/profile/update", { payoutInfo });
        toast.success("Payment settings updated successfully");
        onUpdate();
      } catch (error) {
        toast.error("Failed to update payment settings");
      } finally {
        setLoading(false);
      }
    };
  
    return (
      <div className="space-y-6">
        <div className="bg-white rounded-2xl border border-gray-200/70 shadow-[0_1px_3px_rgba(16,24,40,0.04)] p-6">
          <h2 className="font-['Manrope'] text-xl font-bold tracking-tight text-gray-900 mb-6">
            Payout Information
          </h2>
  
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1.5">
                Bank Account Number
              </label>
              <input
                type="text"
                value={payoutInfo.bankAccount}
                onChange={(e) =>
                  setPayoutInfo({ ...payoutInfo, bankAccount: e.target.value })
                }
                className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-4 focus:ring-purple-500/10 focus:border-purple-500 transition-all"
                placeholder="Enter bank account number"
              />
            </div>
  
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1.5">
                UPI ID
              </label>
              <input
                type="text"
                value={payoutInfo.upiId}
                onChange={(e) =>
                  setPayoutInfo({ ...payoutInfo, upiId: e.target.value })
                }
                className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-4 focus:ring-purple-500/10 focus:border-purple-500 transition-all"
                placeholder="Enter UPI ID"
              />
            </div>
          </div>
  
          <div className="mt-6">
            <button
              onClick={handleSave}
              disabled={loading}
              className="flex items-center space-x-2 bg-gradient-to-r from-purple-600 to-pink-600 text-white h-11 px-5 rounded-xl text-sm font-semibold shadow-md shadow-purple-600/20 hover:shadow-lg disabled:opacity-50 transition-all"
            >
              {loading ? (
                <Loader2 className="w-4 h-4 animate-spin" />
              ) : (
                <Save className="w-4 h-4" />
              )}
              <span>{loading ? "Saving..." : "Save Settings"}</span>
            </button>
          </div>
        </div>
      </div>
    );
  };

    export default PaymentSettings;